import type { DataTableInstance, Row } from "./types";
import React, { Fragment, useMemo } from "react";
import { useDataTableContext } from "./context";
import { DataTableGroupHeader } from "./data-table-group-header";
import { DataTableRow } from "./data-table-row";
import type { DataTableItem } from "./shared";

export interface TableBodyProps<T extends DataTableItem> {
	table: DataTableInstance<T>;
	renderGroupHeader?: (row: Row<T>) => React.ReactNode;
}

export function TableBody<T extends DataTableItem>({
	table,
	renderGroupHeader,
}: TableBodyProps<T>) {
	const context = useDataTableContext();
	const rawRows = table.getRowModel().rows;
	const rows = useMemo(() => {
		return context.injectRowFilter
			? (context.injectRowFilter(rawRows as Row<any>[]) as Array<Row<T>>)
			: rawRows;
	}, [rawRows, context.injectRowFilter]);

	/** Render */
	return (
		<Fragment>
			{rows.map((row) => {
				if (row.getIsGrouped()) {
					return (
						<DataTableGroupHeader
							key={row.id}
							row={row as Row<T>}
							renderGroupHeader={renderGroupHeader}
						/>
					);
				}

				return (
					<DataTableRow
						key={row.id}
						row={row}
					/>
				);
			})}
		</Fragment>
	);
}
